module.exports = __webpack_public_path__ + "img/baozhang.e8bfdb3a.png";